import { ELoanPurpose } from '@if/core/types'
import { getEnvRuntimeVariable } from '@if/core/utils'

export const useDevTools = getEnvRuntimeVariable<boolean>(import.meta.env.VITE_USE_DEV_TOOLS)
export const merchantDashboardUrl = import.meta.env.VITE_MERCHANT_DASHBOARD_URL

export enum ELanguageAbr {
  French = 'fr',
  English = 'en',
}
export const ELanguageAbrList = Object.values(ELanguageAbr)

export enum EMerchantProperties {
  noPaymentPolicy = 'noPaymentPolicy',
  hideAddress = 'hideAddress',
  canSkipFlinks = 'canSkipFlinks',
  canPayBorrowers = 'canPayBorrowers',
  forcePaymentToBorrower = 'forcePaymentToBorrower',
  automaticIncomeApproval = 'automaticIncomeApproval',
  canAcceptHighEstimate = 'canAcceptHighEstimate',
  showInterestRateOnMerchantDashboard = 'showInterestRateOnMerchantDashboard',
}

export enum EMerchantReportFrequency {
  never = 'none',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export enum EValueList {
  Tags = 'Tags',
}

export enum EUserRights {
  canDeleteUser = 'canDeleteUser',
  canViewMerchantDashboard = 'canViewMerchantDashboard',
}

export const DATE_MAX = new Date('9999-12-31')

// Personal loan program constants
export const PERSONAL_MAX_LOAN_AMOUNT_DEFAULT = 40000
export const PERSONAL_MAX_LOAN_AMOUNT_MEDICARD = 50000
export const MEDICARD_SERVICE_CATEGORIES: string[] = [
  ELoanPurpose.Dentistry,
  ELoanPurpose.Medical,
  ELoanPurpose.Aesthetics,
]
